import { SelectField } from "@/components/SelectField";
import type { WizardFieldErrors } from "@/base";
import {
  EL_LIMIT_KEYS,
  EL_LIMITS_HEADER,
  EL_LIMITS_LABEL,
  elLimitOptions,
  elLimitPatch,
  elLimitValue,
} from "@/lib/submissions/wc/coverage";
import type { WcAnswers } from "@/lib/submissions/wc/questions";

// The employers' liability limits as one choice (BRK-S392, PMS-S811) of the
// sets Signal offers (BRK-S508, PMS-S922; Tyler, 10/29), each read "$100,000 |
// $100,000 | $500,000" under its columns' header. Three sets, so a plain
// select, as the manifest's other short lists are. Choosing one fills the three
// limits PMS keeps and sends Great American; the broker sees the set, never the
// three amounts. A refusal of any of the three lands on the choice.

export function ElLimitsField({
  combinations,
  answers,
  onChange,
  errors,
  busy,
}: {
  combinations: readonly (readonly number[])[];
  answers: WcAnswers;
  onChange: (patch: WcAnswers) => void;
  errors: WizardFieldErrors;
  busy: boolean;
}) {
  const options = elLimitOptions(combinations);
  const value = elLimitValue(answers);
  return (
    <SelectField
      label={EL_LIMITS_LABEL}
      help={EL_LIMITS_HEADER}
      options={options}
      placeholder="Choose the limits"
      // Limits PMS holds that aren't a set offered read as nothing chosen.
      value={options.some((o) => o.value === value) ? value : ""}
      onChange={(e) => onChange(elLimitPatch(e.target.value))}
      error={EL_LIMIT_KEYS.map((k) => errors[k]).find(Boolean)}
      disabled={busy}
      required
    />
  );
}
